export const SET_O4_REQUEST = 'SET_O4_REQUEST';
export const SET_O4_FAILED = 'SET_O4_FAILED';
export const SET_O4_PARTNERSHIP_KEY_LIST_SUCCESS = 'SET_O4_PARTNERSHIP_KEY_LIST_SUCCESS';
export const SET_O4_PARTNERSHIP_KEY_SUCCESS = 'SET_O4_PARTNERSHIP_KEY_SUCCESS';
export const CLEAN_O4 = 'CLEAN_O4';
